module.exports = __webpack_public_path__ + "img/bh_13.d374f402.jpg";